/** What a signed-out visitor sees. Deep links stay on sign-in so the URL survives login. */
export type GuestView = 'splash' | 'about' | 'signin';

function normalizePath(pathname: string): string {
  if (pathname.length > 1 && pathname.endsWith('/')) return pathname.slice(0, -1);
  return pathname;
}

export function guestView(pathname: string): GuestView {
  const path = normalizePath(pathname);
  if (path === '/') return 'splash';
  if (path === '/about') return 'about';
  return 'signin';
}
